import React from 'react';
import { useSceneStore } from '../../store/sceneStore';
import { useSceneViewStore } from '../../store/sceneViewStore';
import { ZOOM_PRESETS } from '../../../core/types/scene.types';
import { cn } from '../../utils/cn';

interface SceneStatusBarProps {
  canvasWidth: number;
  canvasHeight: number;
}

export const SceneStatusBar: React.FC<SceneStatusBarProps> = ({
  canvasWidth,
  canvasHeight,
}) => {
  const { selectedIds } = useSceneStore();
  const { viewport, mousePosition, setZoom } = useSceneViewStore();
  const { zoom } = viewport;

  const zoomPercentage = Math.round(zoom * 100);
  const selectionCount = selectedIds.length;


  const handleZoomPresetClick = (preset: number) => {
    setZoom(preset);
  };

  return (
    <div className="flex items-center justify-between h-6 flex-shrink-0 bg-zinc-800 border-t border-zinc-700 px-2 text-xs text-zinc-400 overflow-hidden">
      {/* Left: Canvas Resolution */}
      <div className="flex items-center gap-3 flex-shrink-0 min-w-0">
        <span className="font-mono whitespace-nowrap">
          {canvasWidth} x {canvasHeight}
        </span>
        <span className="text-zinc-600">|</span>
        <span className="whitespace-nowrap">
          Zoom: <span className="font-mono text-zinc-300">{zoomPercentage}%</span>
        </span>
      </div>

      {/* Center: Zoom Presets */}
      <div className="flex items-center gap-1 flex-shrink min-w-0 overflow-hidden">
        {ZOOM_PRESETS.map((preset) => (
          <button
            key={preset}
            className={cn(
              'px-1.5 py-0.5 rounded transition-colors font-mono flex-shrink-0',
              Math.abs(zoom - preset) < 0.01
                ? 'bg-blue-600 text-white'
                : 'hover:bg-zinc-700 text-zinc-500 hover:text-zinc-300'
            )}
            onClick={() => handleZoomPresetClick(preset)}
            title={`Set zoom to ${Math.round(preset * 100)}%`}
          >
            {Math.round(preset * 100)}%
          </button>
        ))}
      </div>

      {/* Right: Mouse Position & Selection Count */}
      <div className="flex items-center gap-3 flex-shrink-0 min-w-0">
        <span className="font-mono whitespace-nowrap">
          X: <span className="text-zinc-300">{Math.round(mousePosition.x)}</span>
        </span>
        <span className="font-mono whitespace-nowrap">
          Y: <span className="text-zinc-300">{Math.round(mousePosition.y)}</span>
        </span>
        <span className="text-zinc-600">|</span>
        <span className="whitespace-nowrap">
          Selected:{' '}
          <span
            className={cn(
              'font-mono',
              selectionCount > 0 ? 'text-blue-400' : 'text-zinc-500'
            )}
          >
            {selectionCount}
          </span>
        </span>
      </div>
    </div>
  );
};
